// extracted by mini-css-extract-plugin
module.exports = {"sun200":"#FEF2DC","blue100":"#E2EBFF","container":"Banner_container__ciSUI"};